module.exports = __webpack_public_path__ + "static/unifiedIt-4274fac004205559b6e7594b94e00e3e.jpg";